<template>
	<div class="espectaculos">
		<div class="espectaculos-header">
			<div class="container">
				<h1>Espectáculos</h1>
				<p>Todos los espectáculos</p>
			</div>
		</div>
		<div class="espectaculos-filtros">
			<div class="container">
				<div class="filtro">
					<label for="filtroTipo">Tipo de espectáculo</label>
					<multiselect v-model="filtros.tipo" :options="filtros.tipos" track-by="descripcion" label="descripcion" :searchable="false" :close-on-select="true" :show-labels="false" placeholder="Todos" :allow-empty="true">
						<template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.descripcion }}</strong></template>
						<span slot="noResult">No se encontró tipo.</span>
						<span slot="noOptions">No hay tipos disponibles.</span>
					</multiselect>
				</div>
			</div>
		</div>
		<div class="espectaculos-main">
			<div class="container">
				<div class="lista-espectaculos">
					<div class="espectaculos-row" v-if="cargandoEspectaculos">
						<vcl-facebook style="margin-right: 20px;"></vcl-facebook>
						<vcl-facebook style="margin-right: 10px;margin-left: 10px;"></vcl-facebook>
						<vcl-facebook style="margin-left: 20px;"></vcl-facebook>
					</div>
					<div class="espectaculos-row" v-else-if="hayEspectaculos">
						<div class="espectaculo-wrapper" v-for="(espectaculo, index) in espectaculosFiltrados" :key="espectaculo.id">
							<a @click="irAEspectaculo(espectaculo.EspectaculoId, index)" class="espectaculo" :class="{ 'espectaculo-alternativo': !espectaculo.EspectaculoTipoRequiereInstitucion, 'pasado': espectaculo.EspectaculoFecha < fechaActual, 'espectaculo-agotado': espectaculo.EspectaculoAgotado }">
								<div class="espectaculo-agotado-overlay" v-if="espectaculo.EspectaculoAgotado">
									<span>Localidades agotadas</span>
								</div>
								<div class="espectaculo-tipo"  :style="{ 'background-color' : '#' + espectaculo.EspectaculoTipoColor }">
									{{ espectaculo.EspectaculoTipoNombre }}
								</div>
								<div class="espectaculo-top" v-if="!espectaculo.EspectaculoTipoRequiereInstitucion && espectaculo.EspectaculoMiniaturaURL">
									<img class="espectaculo-miniatura" :src="espectaculo.EspectaculoMiniaturaURL" :alt="espectaculo.EspectaculoNombre">
								</div>
								<div class="espectaculo-top" v-if="espectaculo.EspectaculoTipoRequiereInstitucion">
									<div class="equipo equipo-local">
										<img v-if="espectaculo.InstitucionLocalEscudoURL !== ''" :src="espectaculo.InstitucionLocalEscudoURL" :alt="espectaculo.InstitucionLocalNombre">
										<span>{{ espectaculo.InstitucionLocalNombre }}</span>
									</div>
									<span class="vs">vs.</span>
									<div class="equipo equipo-visitante">
										<img v-if="espectaculo.InstitucionVisitanteEscudoURL !== ''" :src="espectaculo.InstitucionVisitanteEscudoURL" :alt="espectaculo.InstitucionVisitanteNombre">
										<span>{{ espectaculo.InstitucionVisitanteNombre }}</span>
									</div>
								</div>
								<div class="titulo-alternativo" v-else>
									{{ espectaculo.EspectaculoNombre }}
								</div>
								<div class="espectaculo-info" v-if="espectaculo.EspectaculoFrontMostrarFecha || espectaculo.EspectaculoFrontMostrarEscenario">
									<div class="fecha-lugar">
										<span class="fecha" v-if="espectaculo.EspectaculoFrontMostrarFecha">{{ espectaculo.EspectaculoFechaEscrita }}</span>
										<span class="lugar" v-if="espectaculo.EspectaculoFrontMostrarEscenario">
											<img v-if="espectaculo.EscenarioLogoURL !== ''" :src="espectaculo.EscenarioLogoURL" :alt="espectaculo.EscenarioNombre">
											{{ espectaculo.EscenarioNombre }}
										</span>
									</div>
									<div class="fecha-hora" v-if="espectaculo.EspectaculoFrontMostrarFecha">{{ espectaculo.EspectaculoHora }}</div>
								</div>
								<div class="espectaculo-competencia" v-if="espectaculo.EspectaculoFrontMostrarCompetencia">
									<img v-if="espectaculo.CompetenciaImagenURL !== ''" :src="espectaculo.CompetenciaImagenURL" :alt="espectaculo.CompetenciaNombre">
									<div class="espectaculo-competencia-info">
										<span class="nombre-competencia">{{ espectaculo.CompetenciaNombre }}</span>
										<span class="instancia-competencia">{{ espectaculo.CompetenciaInstanciaNombre }}</span>
									</div>
								</div>
								<div class="espectaculo-bottom">
									<div class="espectaculo-bottom-right"></div>
								</div>
							</a>
						</div>
					</div>
					<div class="espectaculos-row" v-else>
						<span class="no-espectaculos">No se encontraron espectáculos con esos filtros<frown-icon></frown-icon></span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import { VclFacebook } from 'vue-content-loading';
	import { FrownIcon } from 'vue-feather-icons'
	
	export default{
		name: 'espectaculos',
		data(){
			return {
				fechaActual: new Date(),
				filtros: {
					tipo: null,
					tipos: []
				},
				espectaculos: [],
				cargandoEspectaculos: false
			}
		},
		components: {
			VclFacebook,
			FrownIcon
		},
		async mounted(){
			this.$store.dispatch('cargando', true);
			this.cargandoEspectaculos = true;
			await this.tiposEspectaculo();
			await this.cargoEspectaculos();
			this.$store.dispatch('cargando', false);
		},
		computed: {
			espectaculosFiltrados: function(){
				return this.filtrarPorTipo(this.espectaculos)
			},
			hayEspectaculos: function(){
				if(this.espectaculosFiltrados.length > 0){
					return true;
				} else {
					return false;
				}
			}
		},
		methods: {
			filtrarPorTipo: function(espectaculos){
				if(this.filtros.tipo !== null){
					return espectaculos.filter(espectaculo => (parseInt(espectaculo.EspectaculoTipoId) === parseInt(this.filtros.tipo.valor)) ? espectaculo : '');
				} else {
					return espectaculos;
				}

			},
			irAEspectaculo(id, index){
				if(this.espectaculos[index].EspectaculoAgotado === true){
					this.$store.dispatch('mostrarError', '¡Localidades agotadas!')
				} else {
					this.$router.push({ name: 'espectaculo', params: { espectaculoId: parseInt(id) } })
				}
			},
			async tiposEspectaculo(){
				// Obtengo los tipos de espectáculo
				try {
					let response = await axios.post('/WSEspectaculosTipo', {});
					
					if(response.data.ErrorCod === 0){
						for(var m=0; m<response.data.SDTEspectaculosTipo.length; m++){
							this.filtros.tipos.push({ valor: parseInt(response.data.SDTEspectaculosTipo[m].EspectaculoTipoId), descripcion: response.data.SDTEspectaculosTipo[m].EspectaculoTipoNombre });
						}
					}
				} catch (error) {
					this.$router.push({ name: 'error' });
				}
			},
			async cargoEspectaculos(){
				// Obtengo los espectáculos del inicio
				try {
					let response = await axios.post('/WSEspectaculos', {});

					if(response.data.ErrorCod === 0){
						if(response.data.SDTEspectaculos.length > 0){
							// this.hayEspectaculos = true;
							this.espectaculos = response.data.SDTEspectaculos;

							for(var i=0; i<this.espectaculos.length; i++){
								var fecha = new Date(this.espectaculos[i].EspectaculoFecha);
								this.espectaculos[i].EspectaculoFecha = fecha;
							}
						} else {
							// this.hayEspectaculos = false;
							this.espectaculos = [];
						}
					}
	
					this.cargandoEspectaculos =  false
				} catch (error) {
					this.$router.push({ name: 'error' });
				}
			}
		}
	}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
	// Multiselects
	.multiselect {
		min-height: 44px;
		width: 100%;
		cursor: pointer;
		transition: all 0.2s;

		&:hover .multiselect__tags {
			transition: all 0.2s;
			border-color: var(--color-blue);
		}
	}

	.multiselect__input,
	.multiselect__single {
		margin: 0;
		font-size: 16px;
		line-height: 25px;
		font-weight: var(--font-weight-bold);
		-webkit-letter-spacing: 0;
		-moz-letter-spacing: 0;
		-ms-letter-spacing: 0;
		letter-spacing: 0;
		color: var(--color-dark);
		font-family: var(--font-family-poppins);
		text-transform: uppercase;
		padding-left: 0;
	}

	.multiselect__tags {
		border-radius: 0px;
		font-size: 16px;
		line-height: 25px;
		border: none;
		border-bottom: 1px solid var(--color-grey-light);
		display: block;
		width: 100%;
		height: 100%;
		font-weight: var(--font-weight-bold);
		-webkit-letter-spacing: 0;
		-moz-letter-spacing: 0;
		-ms-letter-spacing: 0;
		letter-spacing: 0;
		color: var(--color-dark);
		font-family: var(--font-family-poppins);
		text-transform: uppercase;
		padding-top: 8px;
		padding-bottom: 10px;
		padding-left: 0px;
		padding-right: 40px;
		outline: none;
		background-color: var(--color-white);
	}

	.multiselect__option--highlight {
		background-color: var(--color-grey-lighter);
		color: var(--color-black);
	}

	.multiselect__option--selected.multiselect__option--highlight {
		background-color: var(--color-red);
		// border-left: 2px solid var(--color-blue-dark);
		color: var(--color-white);
	}

	.multiselect__option {
		font-size: 13px;
		line-height: 13px;
		font-weight: var(--font-weight-bold);
		-webkit-letter-spacing: 0;
		-moz-letter-spacing: 0;
		-ms-letter-spacing: 0;
		letter-spacing: 0;
		color: var(--color-dark);
		font-family: var(--font-family-poppins);
		text-transform: uppercase;
	}

	.multiselect__option--selected {
		background-color: var(--color-blue);
		color: var(--color-white);
		font-size: 13px;
		line-height: 13px;
	}

	.multiselect__option--highlight:after {
		background: transparent;
		color: #999;
		font-size: 12px;
		font-weight: 300;
	}

	.multiselect__option--selected.multiselect__option--highlight:after,
	.multiselect__option--selected:after {
		background: transparent;
		color: var(--color-white);
		font-size: 12px;
		font-weight: 300;
	}

	.multiselect__tag {
		margin-bottom: 3px !important;
		margin-right: 8px !important;
		background: var(--color-blue) !important;
	}

	.multiselect__tag-icon:after {
		color: var(--color-white) !important;
	}

	.multiselect__tag-icon:focus,
	.multiselect__tag-icon:hover {
		background: none !important;
	}

	.multiselect__placeholder {
		padding-top: 0px;
		margin-bottom: 0px;
	}
</style>

<style lang="scss" scoped>
	.espectaculos{
		min-height: var(--height-page);
		// background-color: var(--color-grey-lighter);
		width: 100%;
		margin: 0;
		padding: 0;
		position: relative;
		@include flex(column, flex-start, center);

		.espectaculos-header{
			background-color: var(--color-white);
			padding-top: 72px;
			width: 100%;
			position: relative;
			@include flex(column, flex-start, center);

			.container{
				@include flex(column, center, flex-start);
				padding: 20px 0;

				h1{
					margin: 0;
					color: var(--color-red);
					font-weight: initial;
					font-size: 48px;
					line-height: 46px;
					font-family: var(--font-family-kapra-bold);
					text-transform: uppercase;
				}

				p{
					margin: 0;
					font-size: 18px;
					line-height: 26px;
					font-family: var(--font-family-fira);
					font-weight: bold;
					color: var(--color-dark);
				}
			}
		}

		.container{
			height: 100%;
			margin: 0;
			width: 100%;
			max-width: 1260px;
		}

		.espectaculos-filtros{
			width: 100%;
			margin-top: 0;
			padding: 20px 0;
			// border-bottom: 1px solid var(--color-grey-light);
			background: var(--color-white);
			z-index: 10;
			@include flex(row, center, center);
			
			.container{
				@include flex(row, flex-start, center);

				.filtro{
					min-width: 320px;
					@include flex(column, center, flex-start);
					margin-right: 20px;

					label{
						font-size: 16px;
						font-weight: var(--font-weight-regular);
						color: var(--color-grey);
						-webkit-letter-spacing: 0;
						-moz-letter-spacing: 0;
						-ms-letter-spacing: 0;
						letter-spacing: 0;
						line-height: 19px;
						font-family: var(--font-family-fira);
					}

					input{
						font-size: 16px;
						line-height: 25px;
						padding-top: 8px;
						border-bottom: 1px solid var(--color-grey-light);
						display: block;
						width: 100%;
						font-weight: var(--font-weight-bold);
						-webkit-letter-spacing: 0;
						-moz-letter-spacing: 0;
						-ms-letter-spacing: 0;
						letter-spacing: 0;
						color: var(--color-dark);
						font-family: var(--font-family-poppins);
						text-transform: uppercase;
						padding-top: 8px;
						padding-bottom: 10px;

						&:focus{
							border-color: var(--color-blue);
						}
					}

					// .filtroEstado{
					// 	@include flex(row, flex-start, center);

					// 	.estado{
					// 		margin: 0;
					// 		margin-right: 8px;
					// 		border: 1px solid #f3f3f9;
					// 		border-radius: 4px;
					// 		@include flex(row, center, center);
					// 		padding: 10px 14px;
					// 		font-weight: 400;
					// 		font-size: 13px;
					// 		color: #555;
					// 		background-color: #f3f3f9;
					// 		font-size: 12px;
					// 		font-weight: 800;
					// 		cursor: pointer;

					// 		&.activo{
					// 			border-color: #007bff;
					// 			color: #fff;
					// 			background: #007bff;
					// 		}
							
					// 		&.focus{
					// 			border-color: #007bff;
					// 		}
					// 	}
					// }

					// select{
					// 	width: 100%;
					// 	outline: none;
					// 	border: 1px solid #f3f3f9;
					// 	border-radius: 4px;
					// 	padding: 10px 14px 10px 14px;
					// 	font-size: 12px;
					// 	font-weight: 800;
					// 	background-color: #f3f3f9;
					// 	box-shadow: none;
					// 	transition: all .2s;
					// 	color: #555;
					// 	@include sinApariencia();
					// 	@include isSelect();

					// 	&:focus{
					// 		background-color: #f3f3f9;
					// 		border: 1px solid #007bff;
					// 	}
					// }
				}
			}
		}

		.espectaculos-main{
			width: 100%;
			margin-top: 0;
			@include flex(row, center, flex-start);
			
			.container{
				@include flex(column, flex-start, flex-start);

				.lista-espectaculos{
					width: 100%;
					margin: 30px 0;
					
					.espectaculos-row{
						@include flex(row, flex-start, center);
						flex-wrap: wrap;
						width: 100%;
						margin: 0;
						margin-bottom: 30px;
						margin-top: 10px;

						& > svg{
							width: 390px;
						}

						.no-espectaculos{
							width: 100%;
							margin: 0;
							background-color: #f3f3f9;
							border-radius: 4px;
							line-height: 1em;
							padding: 15px;
							font-weight: 700;
							font-size: 13px;
							@include flex(row, center, center);

							svg{
								line-height: 1em;
								width: 16px;
								height: 16px;
								margin-left: 5px;
							}
						}

						.espectaculo-wrapper{
							@include flex(column, center, center);
							width: calc(33% - 20px);
							margin: 0;
							margin-bottom: 35px;

							&:nth-child(3n - 2){
								margin-right: 15px;
							}

							&:nth-child(3n - 1){
								margin-left: 15px;
								margin-right: 15px;
							}

							&:nth-child(3n){
								margin-left: 15px;
							}
						}

						.espectaculo{
							width: 100%;
							min-height: 267px;
							border-radius: 0px;
							padding: 20px;
							padding-bottom: 27px;
							position: relative;
							cursor: pointer;
							box-shadow: 0 2px 28px 0 rgba(0, 0, 0, 0.07);
							margin: 0;
							transition: all .2s;
							text-decoration: none;
							background-color: var(--color-white);

							&.espectaculo-agotado{
								.espectaculo-tipo{
									background-color: var(--color-grey-medium) !important;
									color: var(--color-grey);
								}

								.espectaculo-bottom{
									background-color: var(--color-grey-light);

									.espectaculo-bottom-right{
										background-color: var(--color-grey-lighter);
									}
								}

								.espectaculo-agotado-overlay{
									position: absolute;
									top: 0;
									left: 0;
									width: 100%;
									height: 100%;
									@include flex(column, center, center);
									background-color: rgba(255, 255, 255, 0.8);

									span{
										color: var(--color-white);
										font-weight: var(--font-weight-bold);
										font-size: 17px;
										font-family: var(--font-family-poppins);
										padding: 8px 10px;
										text-transform: uppercase;
										background-color: var(--color-red);
										transform: rotate(-20deg);
										-webkit-transform: rotate(-20deg);
									}
								}
							}

							&.pasado{
								// background: #f3f3f9;
								color: #666;
								box-shadow: none;
								border: 1px solid rgba(197, 197, 206, 0.26);
								cursor: auto;

								.espectaculo-tipo{
									background-color: #c5c5ce !important;
								}

								.espectaculo-top{
									.equipo{
										span{
											color: #666;
										}

										img{
											filter: grayscale(100%);
										}
									}

									span.vs{
										color: #666;
									}
								}

								.espectaculo-info{
									.fecha-lugar{
										.fecha{
											color: #666;
										}

										.lugar{
											color: #666;
											img{
												filter: grayscale(100%);
											}
										}
									}

									.fecha-hora{
										color: #666;
										border-left-color: #f1f1f1;
									}
								}

								.espectaculo-competencia{
									img{
										filter: grayscale(100%);
									}

									.espectaculo-competencia-info{
										.nombre-competencia{
											color: #666;
										}

										.instancia-competencia{
											color: #666;
										}
									}
								}

								.espectaculo-bottom{
									// display: none;
									background-color: #c5c5ce;

									.espectaculo-bottom-right{
										background-color: #a9a9b3;
									}
								}
							}

							.espectaculo-tipo{
								position: absolute;
								left: 50%;
								transform: translateX(-50%);
								top: -9px;
								border-radius: 44px;
								padding: 3px 12px;
								background-color: var(--color-red);
								color: var(--color-white);
								font-size: 10px;
								line-height: 1.3em;
								text-transform: uppercase;
								font-family: var(--font-family-poppins);
							}

							.espectaculo-top{
								display: flex;
								flex-direction: row;
								justify-content: space-around;
								align-items: flex-start;
								margin: 0;
								padding: 0;
								padding-bottom: 25px;

								.equipo{
									display: flex;
									flex-direction: column;
									justify-content: flex-start;
									align-items: center;
									width: calc(50% - 15px);

									img{
										height: 64px;
										width: auto;
									}

									span{
										font-family: var(--font-family-poppins);
										font-weight: var(--font-weight-bold);
										font-size: 15px;
										color: var(--color-blue-dark);
										text-align: center;
										line-height: 1.3em;
										margin-top: 10px;
										min-height: 32px;
										-webkit-letter-spacing: -0.4px;
										-moz-letter-spacing: -0.4px;
										-ms-letter-spacing: -0.4px;
										letter-spacing: -0.4px;
										text-transform: uppercase;
										@include flex(column, center, center);
									}
								}

								span.vs{
									font-family: var(--font-family-fira);
									color: var(--color-red);
									font-weight: var(--font-weight-bold);
									text-align: center;
									line-height: 1.2em;
									font-size: 20px;
									max-width: 30px;
									@include flex(column, center, center);
									height: 64px;
								}

								.espectaculo-miniatura{
									height: 80px;
									margin-bottom: -35px;
								}
							}

							&:hover{
								box-shadow: 0 2px 48px 0 rgba(0, 0, 0, 0.12);
							}

							button{
								padding: 8px 12px;
								display: flex;
								flex-direction: row;
								justify-content: center;
								align-items: center;
								font-size: 13px;
								font-weight: 600;
								line-height: 1em;
								text-transform: uppercase;
								outline: none;
								color: #fff;
								border: none;
								background: #b5162f;
								border-radius: 4px;
								cursor: pointer;
								margin: 10px 0;
								transition: all .2s;

								svg{
									stroke-width: 1.8;
									width: 18px;
									height: 18px;
									margin-left: 8px;
								}
							}

							&:hover{
								box-shadow: 0 2px 48px 0 rgba(0, 0, 0, 0.12);

								button{
									background: rgba(181, 22, 47, 0.9);
								}
							}

							.espectaculo-info{
								width: 100%;
								display: flex;
								flex-direction: row;
								justify-content: center;
								align-items: center;
								margin-bottom: 15px;

								.fecha-calendar{
									width: 40px;
									height: 40px;
									overflow: hidden;
									padding: 0;
									margin: 0;
									margin-right: 14px;
									border: 1px solid #054085;
									background-color: #fff;
									border-radius: 4px;
									display: flex;
									flex-direction: column;
									align-items: center;
									justify-content: center;

									.fecha-calendar-mes{
										color: #054085;
										text-transform: uppercase;
										font-size: 11px;
										font-weight: 800;
									}

									.fecha-calendar-dia{
										color: #054085;
										text-transform: uppercase;
										font-size: 18px;
										font-weight: 600;
									}
								}

								.fecha-lugar{
									@include flex(column, center, flex-start);

									.fecha{
										font-weight: var(--font-weight-regular);
										font-size: 15px;
										color: var(--color-blue-dark);
										font-family: var(--font-family-fira);
										line-height: 1.3em;
									}

									.lugar{
										font-weight: var(--font-weight-bold);
										font-size: 14px;
										color: var(--color-blue-dark);
										font-family: var(--font-family-fira);
										line-height: 1.3em;

										img{
											margin-right: 7px;
											width: 28px;
											height: auto;
										}
									}
								}

								.fecha-hora{
									color: var(--color-blue-dark);
									font-size: 20px;
									padding-left: 10px;
									border-left: 1px solid var(--color-blue-dark);
									margin-left: 20px;
									font-family: var(--font-family-poppins);
									font-weight: var(--font-weight-bold);
								}
							}

							.espectaculo-competencia{
								width: 100%;
								@include flex(row, center, center);

								img{
									max-height: 28px;
									width: auto;
									margin-right: 15px;
								}

								.espectaculo-competencia-info{
									@include flex(column, center, flex-start);

									.nombre-competencia{
										color: var(--color-blue-dark);
										font-size: 13px;
										font-weight: var(--font-weight-bold);
										font-family: var(--font-family-fira);
										line-height: 1.3em;
									}

									.instancia-competencia{
										color: var(--color-blue-dark);
										font-size: 12px;
										font-weight: var(--font-weight-regular);
										font-family: var(--font-family-fira);
										line-height: 1.3em;
									}
								}
							}

							.espectaculo-bottom{
								width: 100%;
								background-color: var(--color-blue-dark);
								height: 7px;
								border-radius: 0;
								position: absolute;
								bottom: 0;
								left: 0;
								padding: 0 20px;
								margin: 0;
							}

							.espectaculo-bottom-right{
								width: 50%;
								background-color: var(--color-red);
								height: 7px;
								border-radius: 0;
								position: absolute;
								bottom: 0;
								right: 0;
								padding: 0 20px;
								margin: 0;
							}

							&.espectaculo-alternativo{
								display: flex;
								flex-direction: column;
								justify-content: space-evenly;

								.titulo-alternativo{
									font-family: var(--font-family-poppins);
									color: var(--color-blue-dark);
									line-height: 1.2em;
									font-size: 26px;
									font-weight: var(--font-weight-bold);
									text-align: center;
									width: 100%;
									text-transform: uppercase;
									margin-bottom: 15px;
								}

								.espectaculo-info{
									margin-bottom: 0px;
								}
							}
						}
					}
				}
			}
		}
	}

	/* Responsive */
	@media screen and (max-width: 1308px){
		.espectaculos{
			.espectaculos-header{
				.container{
					padding-left: 24px;
					padding-right: 24px;
				}
			}

			.espectaculos-filtros{
				.container{
					padding-left: 24px;
					padding-right: 24px;
				}
			}

			.espectaculos-main{
				.container{
					padding-left: 24px;
					padding-right: 24px;
				}
			}
		}
	}

	@media screen and (max-width: 1164px){
		.espectaculos{
			.espectaculos-main{
				.container{
					.lista-espectaculos{
						.espectaculos-row{
							@include flex(row, space-between, center);

							.espectaculo-wrapper{
								width: calc(50% - 15px);

								&:nth-child(3n - 2){
									margin-right: 0px;
								}

								&:nth-child(3n - 1){
									margin-left: 0px;
									margin-right: 0px;
								}

								&:nth-child(3n){
									margin-left: 0px;
								}
							}
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 890px){
		.espectaculos{
			.espectaculos-filtros{
				position: relative;
				top: auto;
				
				.container{
					flex-wrap: wrap;

					.filtro{
						margin-bottom: 10px;
						margin-top: 10px;
					}
				}
			}
		}
	}

	@media screen and (max-width: 790px){
		.espectaculos{
			.espectaculos-filtros{
				.container{
					.filtro{
						margin-right: 0px;
						width: 100%;
						min-width: auto;
					}
				}
			}

			.espectaculos-main{
				.container{
					.lista-espectaculos{
						.espectaculos-row{
							.espectaculo-wrapper{
								width: 100%;
							}
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 460px){
		.espectaculos{
			.espectaculos-main{
				.container{
					.lista-espectaculos{
						.espectaculos-row{
							.espectaculo {
								min-height: auto;
								
								.espectaculo-top{
									span.vs{
										font-size: 15px;
									}

									.equipo{
										img{
											height: 46px;
										}
									}
								}

								.espectaculo-info{
									.fecha-lugar{
										.fecha{
											font-size: 14px;
										}

										.lugar{
											font-size: 13px;

											img{
												width: 23px;
											}
										}
									}

									.fecha-hora{
										font-size: 22px;
									}
								}

								.espectaculo-competencia{
									img{
										max-height: 24px;
									}
								}
							}
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 400px){
		.espectaculos{
			.espectaculos-main{
				.container{
					.lista-espectaculos{
						.espectaculos-row{
							.espectaculo {
								.espectaculo-tipo{
									// width: 70%;
									text-align: center;
								}

								.espectaculo-top{
									.equipo{
										img{
											height: 38px;
										}

										span{
											font-size: 13px;
										}
									}
								}

								.espectaculo-info{
									.fecha-hora{
										font-size: 16px;
									}

									.fecha-lugar{
										.fecha{
											font-size: 12px;
										}

										.lugar{
											font-size: 12px;

											img{
												margin-right: 4px;
												width: 20px;
											}
										}
									}
								}

								.espectaculo-competencia{
									.espectaculo-competencia-info{
										.nombre-competencia{
											font-size: 12px;
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
</style>